<template>
  <div id="edit-live-stream-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else-if="form" key="content-loading">
          <el-row>
            <el-col :span="24">
              <div class="menu-container">
                <div class="menu-item" :class="{ active: menuType == 0 }" @click="menuType = 0">{{ $t("liveSessions.editLiveStream.information") }}</div>
                <!-- <div class="menu-item" :class="{ active: menuType == 1 }" @click="menuType = 1" v-if="form.sessionType == 0">
                  {{ $t("liveSessions.editLiveStream.speakers") }}
                  <span>{{ form.publishers ? form.publishers.length : "" }}</span>
                </div> -->
                <div class="menu-item" :class="{ active: menuType == 2 }" @click="menuType = 2" v-if="form.sessionType != 0">{{ $t("liveSessions.editLiveStream.broadcastTitle") }}</div>
                <div class="menu-item" :class="{ active: menuType == 3 }" @click="menuType = 3">
                  {{ $t("liveSessions.editLiveStream.scenesTitle") }}
                  <span>{{ $store.state.livesessions.listScenes.length }}</span>
                </div>
                <div class="menu-item" :class="{ active: menuType == 4 }" @click="menuType = 4">{{ $t("liveSessions.editLiveStream.settingsTitle") }}</div>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="menuType == 0" :gutter="20">
            <el-col :span="14">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.editLiveStream.info.title") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.editLiveStream.info.titleMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.title"></el-input>
                    <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="14" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.editLiveStream.info.startDate") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.editLiveStream.info.startDateMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-date-picker :format="datePickerDisplayFormat()" v-model="form.startDate" class="w-100" type="date" :placeholder="$t('liveSessions.editLiveStream.info.placeholderChooseDate')"></el-date-picker>
                    <span class="error">{{ $errorMessage("startDate", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="10" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.editLiveStream.info.startTime") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.editLiveStream.info.startTimeMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-time-select style="width:100%;" v-model="form.startTime" :placeholder="$t('liveSessions.editLiveStream.info.placeholderChooseHour')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                    <span class="error">{{ $errorMessage("startTime", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="14" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.editLiveStream.info.endDate") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.editLiveStream.info.endDateMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-date-picker :format="datePickerDisplayFormat()" v-model="form.endDate" type="date" class="w-100" :placeholder="$t('liveSessions.editLiveStream.info.placeholderChooseDate')"></el-date-picker>
                    <span class="error">{{ $errorMessage("endDate", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="10" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.editLiveStream.info.endTime") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.editLiveStream.info.endTimeMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-time-select style="width:100%;" v-model="form.endTime" :placeholder="$t('liveSessions.editLiveStream.info.placeholderChooseHour')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                    <span class="error">{{ $errorMessage("endTime", validationErrors) }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="10">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("liveSessions.editLiveStream.info.coverImg") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("liveSessions.editLiveStream.info.coverImgMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="mage-maker drag" :style="{ background: form.image ? `url(${$imageus + form.image + '?width=1120&height=500&mode=cover'})` : 'none', 'border-radius': '5px' }">
                  <el-upload :onProgress="liveProgress" :style="{ opacity: !!form.image ? '0' : '1' }" class="avatar-uploader cover-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveEvent&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="liveSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
              </div>
            </el-col>

            <!-- <el-col :span="24" class="mt-3">
              <el-popover placement="top-start" width="600" trigger="click">
                <div v-html="$t('liveSessions.editLiveStream.info.imporantInformationAll')"></div>
                <button slot="reference" class="reset-btn">
                  <el-alert type="warning " :title="$t('liveSessions.editLiveStream.info.imporantInformation')" :show-icon="true" :closable="false">
                    <div>
                      <span>{{ $t("liveSessions.editLiveStream.info.imporantInformationMsg") }}</span>
                    </div>
                  </el-alert>
                </button>
              </el-popover>
            </el-col> -->
          </el-row>

          <el-row v-if="menuType == 1">
            <el-row :gutter="10">
              <el-col :span="24">
                <div class="add-manager-container">
                  <div class="add-manager-wrapper">
                    <el-select v-model="lastSpeakerId" clearable @clear="lastSpeakerId = null" filterable remote :remote-method="remoteSearch" :loading="loading == 'remoteSearch'" :placeholder="$t('liveSessions.editLiveStream.placeholderAddSpeaker')">
                      <el-option v-for="(item, index) in remoteParticipants" :key="index" :label="item.fullName" :value="item.id"></el-option>
                    </el-select>
                    <div class="add-m-btn">
                      <el-button round size="small" type="primary" @click="addSpeaker">{{ $t("liveSessions.editLiveStream.speaker.add") }}</el-button>
                    </div>
                  </div>
                  <template v-if="form.publishers.length > 0">
                    <div class="speakers-h-title">
                      <div></div>
                      <div>{{ $t("liveSessions.editLiveStream.speaker.speaker") }}</div>
                      <div>{{ $t("liveSessions.editLiveStream.speaker.task") }}</div>
                      <div>{{ $t("liveSessions.editLiveStream.speaker.broadcast") }}</div>
                      <div></div>
                    </div>
                    <draggable :list="form.publishers" tag="div" handle=".el-icon-s-grid" class="list-group-o speakers-h-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                      <div class="item" v-for="(item, index) in form.publishers" :key="index" :class="{ passive: !item.isActive }">
                        <div class="table-icon">
                          <i class="el-icon-s-grid burger"></i>
                        </div>
                        <div class="img-title" v-if="getParticipantItem(item.participantID)" :key="bulkParticipant.length + '-participantsBulks-' + index">
                          <div class="img-title-alt">
                            <div class="networking-title">
                              <div>#{{ getParticipantItem(item.participantID).participantNO }}</div>
                              {{ getParticipantItem(item.participantID).firstName + " " + getParticipantItem(item.participantID).lastName }}
                              <div class="color-title">
                                <div class="circle-color-pick" :style="{ 'background-color': $store.state.tags.items.find(x => x.id == getParticipantItem(item.participantID).tagID).color }"></div>
                                {{ $store.state.tags.items.find(x => x.id == getParticipantItem(item.participantID).tagID).title }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="speaker-task">
                          <el-select v-model="item.type" v-if="getEnums">
                            <el-option v-for="(option, index) in getEnums.find(x => x.title == 'LiveStreamParticipantType').enums" :disabled="option.key == 3" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                        </div>
                        <div><el-switch v-model="item.isActive" @change="permControl(item)"></el-switch></div>
                        <div style="display:flex; flex-direction:row;gap:.5rem">
                          <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
                            <el-popconfirm @confirm="form.publishers.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                              <el-button slot="reference" type="danger" icon="fas fa-trash" size="mini" circle></el-button>
                            </el-popconfirm>
                          </el-tooltip>
                        </div>
                      </div>
                    </draggable>
                  </template>
                  <el-alert v-else type="info" :show-icon="true" :title="$t('liveSessions.editLiveStream.broadcast.noSpeaker')" :closable="false"></el-alert>
                </div>
              </el-col>
            </el-row>
          </el-row>

          <el-row v-if="menuType == 2 && form.sessionType == 1">
            <el-col :span="24">
              <div class="rtmp-container">
                <div class="empty-box">
                  <div class="logo-side">
                    <img src="../../../static/images/stream/rtmp.svg" width="100%" alt="" />
                  </div>
                  <div class="text-side">
                    {{ $t("liveSessions.editLiveStream.broadcast.streamFromSomething") }}
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-title">{{ $t("liveSessions.editLiveStream.broadcast.streamRtmp") }}</div>
                  <div class="info-detail mt-2 mb-2">{{ $t("liveSessions.editLiveStream.broadcast.streamRtmpMsg") }}</div>

                  <span class="rtmp-user-title">{{ $t("liveSessions.editLiveStream.server") }}</span>
                  <el-tooltip class="item" effect="dark" :content="$t('liveSessions.rtmpCopy')" placement="top">
                    <div class="rtmp-url" v-clipboard:success="copySuccess" v-clipboard="form.rmtpUrl.slice(0, 29)">
                      <i class="fas fa-clone"></i>
                      <span>{{ form.rmtpUrl.slice(0, 29) }}</span>
                    </div>
                  </el-tooltip>

                  <span class="rtmp-user-title">{{ $t("liveSessions.editLiveStream.serverKey") }}</span>
                  <el-tooltip class="item" effect="dark" :content="$t('liveSessions.rtmpCopy')" placement="top">
                    <div class="rtmp-url" v-clipboard:success="copySuccess" v-clipboard="form.rmtpUrl.slice(30, form.rmtpUrl.lenght)">
                      <i class="fas fa-clone"></i>
                      <span>{{ form.rmtpUrl.slice(30, form.rmtpUrl.lenght) }}</span>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="24" class="rtmp-preview">
              <div class="preview-container">
                <div class="preview-title">
                  {{ $t("liveSessions.editLiveStream.broadcast.preview") }}
                </div>
                <video src="wss://rtmp.holacon.com/live/62f12b117564f3d5309ff982.flv?sign=1661286369-64047911091bd9a436398a19a89c7a8d" style="aspect-ratio:16/9" playsinline autoplay></video>
              </div>
            </el-col> -->
          </el-row>

          <el-row v-if="menuType == 2 && form.sessionType == 2">
            <el-col :span="24" v-if="form.externalLivestreamProviders.length > 0">
              <div class="external-link-title">
                <div></div>
                <div class="header-item">
                  {{ $t("liveSessions.editLiveStream.broadcast.title") }}
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("liveSessions.editLiveStream.broadcast.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="header-item">
                  {{ $t("liveSessions.editLiveStream.broadcast.platform") }}
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("liveSessions.editLiveStream.broadcast.platformMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="header-item">
                  {{ $t("liveSessions.editLiveStream.broadcast.source") }}
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("liveSessions.editLiveStream.broadcast.sourceMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="switch-title header-item">
                  {{ $t("liveSessions.editLiveStream.broadcast.broadcast") }}
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("liveSessions.editLiveStream.broadcast.broadcastMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div></div>
              </div>
              <draggable class="external-link-container list-group-o" handle=".el-icon-s-grid" :list="form.externalLivestreamProviders" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                <div class="item" v-for="(item, index) in form.externalLivestreamProviders" :key="index" :class="{ passive: !item.isActive }">
                  <div class="table-icon">
                    <i class="el-icon-s-grid burger"></i>
                  </div>
                  <div>
                    <el-input v-model="item.title" :class="$inputError('externalLivestreamProviders[' + index + '].Title', validationErrors)"></el-input>
                  </div>
                  <div>
                    <el-select v-model="item.type" v-if="getEnums" :class="$inputError('externalLivestreamProviders[' + index + '].Type', validationErrors)">
                      <el-option v-for="(option, index) in getEnums.find(x => x.title == 'LiveSessionExternalProvider').enums.filter(k => k.key == 0 || k.key == 1)" :label="option.displayName" :value="option.key" :key="index"></el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-input v-model="item.url" :class="$inputError('externalLivestreamProviders[' + index + '].Url', validationErrors)"></el-input>
                  </div>
                  <div class="switch-title"><el-switch v-model="item.isActive"></el-switch></div>
                  <div><el-button icon="el-icon-close" circle size="mini" @click="form.externalLivestreamProviders.splice(index, 1)" type="danger"></el-button></div>
                </div>
              </draggable>

              <el-col :span="24" class="d-flex justify-content-end mt-2">
                <el-button round icon="fas fa-plus" type="primary" size="mini" @click="addLiveProvider">{{ $t("liveSessions.editLiveStream.broadcast.addSource") }}</el-button>
              </el-col>
            </el-col>

            <el-col :span="24" class="d-flex align-center justify-content-center" v-if="form.externalLivestreamProviders.length == 0">
              <div class="external-empty">
                <div class="empty-box">
                  <div class="logo-side">
                    <!-- <img src="../../../static/images/stream/vimeo.svg" alt="" /> -->
                    <i class="fa fa-code" style="font-size:82px; color:black"></i>
                  </div>
                  <div class="text-side">
                    {{ $t("liveSessions.createLiveStream.vimeoMsg") }}
                  </div>
                </div>
                <el-button size="mini" round icon="fas fa-plus" type="primary" style="width:145px;" @click="addLiveProvider">{{ $t("liveSessions.editLiveStream.broadcast.addOneSource") }}</el-button>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="menuType == 3">
            <upgrade-overlay v-if="false" height="300px"></upgrade-overlay>

            <el-row :gutter="10" v-if="true">
              <el-col :span="24" class="add-manager-container"></el-col>

              <div class="ls-container">
                <upgrade-overlay v-if="false" height="300px"></upgrade-overlay>
                <div class="live-session-wrapper">
                  <div class="live-session-container" :style="'background-image: url(' + $imageus + updateForm.background + '?width=1920&height=1200&mode=cover);'">
                    <div class="live-session-inner">
                      <div class="live-session-banner" :style="'background-image: url(' + $imageus + updateForm.top + '?width=1000&height=100&mode=contain);'">
                        <el-upload :onProgress="topProgress" class="banner" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveTopBanner&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="topSuccess">
                          <div class="message-text">
                            <span>
                              <b>{{ $t("liveSessions.editLiveStream.scenes.headBanner") }}</b>
                            </span>
                            <span>{{ $t("liveSessions.editLiveStream.scenes.headBannerMsg") }}</span>
                          </div>
                          <el-progress :percentage="topPercent" v-if="topPercent != 0"></el-progress>
                        </el-upload>
                      </div>

                      <div class="live-session-background">
                        <el-upload :onProgress="backgroundProgress" class="background" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveBackgroundBanner&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="backgroundSuccess">
                          <div class="message-text">
                            <span>
                              <b>{{ $t("liveSessions.editLiveStream.scenes.bg") }}</b>
                            </span>
                            <span>{{ $t("liveSessions.editLiveStream.scenes.bgMsg") }}</span>
                          </div>
                          <el-progress :percentage="backgroundPercent" v-if="backgroundPercent != 0"></el-progress>
                        </el-upload>
                      </div>

                      <div class="live-session-banner" :style="'background-image: url(' + $imageus + updateForm.bottom + '?width=1000&height=100&mode=contain);'">
                        <el-upload :onProgress="bottomProgress" class="banner" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveBottomBanner&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="bottomSuccess">
                          <div class="message-text">
                            <span>
                              <b>{{ $t("liveSessions.editLiveStream.scenes.footBanner") }}</b>
                            </span>
                            <span>{{ $t("liveSessions.editLiveStream.scenes.footBannerMsg") }}</span>
                          </div>
                          <el-progress :percentage="bottomPercent" v-if="bottomPercent != 0"></el-progress>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="edit-session">
                  <el-input v-model="updateForm.title" :placeholder="$t('liveSessions.editLiveStream.placeholderNameDesign')" clearable></el-input>
                  <el-button round size="small" type="primary" :loading="loading == 'scenesLoading'" @click="saveScenes">{{ $t("liveSessions.editLiveStream.scenes.save") }}</el-button>
                </div>
              </div>
            </el-row>

            <el-row>
              <VueSlickCarousel :arrows="true" :slidesPerRow="4" class="scenes-slick-base" :key="swiperKey">
                <div class="item">
                  <div class="live-session-container radius">
                    <div class="live-session-inner">
                      <div class="live-session-banner"></div>
                      <div class="live-session-background"></div>
                      <div class="live-session-banner"></div>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-title">
                      {{ $t("liveSessions.editLiveStream.scenes.newTemplate") }}
                    </div>
                    <div class="info-btns">
                      <el-button size="mini" type="primary" :loading="loading == 'createSceneLoading'" round @click="createScene">{{ $t("liveSessions.editLiveStream.scenes.createScene") }}</el-button>
                    </div>
                  </div>
                </div>

                <div class="item" v-for="scene in $store.state.livesessions.listScenes" :key="scene.id">
                  <div class="live-session-container radius" :style="'background-image: url(' + $imageus + scene.background + '?width=1920&height=1200&mode=cover);'" :class="{ active: form.sceneID == scene.id }">
                    <div class="live-session-inner">
                      <div class="live-session-banner" :style="'background-image: url(' + $imageus + scene.top + '?width=1000&height=100&mode=contain);'"></div>
                      <div class="live-session-background"></div>
                      <div class="live-session-banner" :style="'background-image: url(' + $imageus + scene.bottom + '?width=1000&height=100&mode=contain);'"></div>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-title">
                      {{ scene.title }}
                    </div>
                    <div class="info-btns">
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("liveSessions.editLiveStream.scenes.success") }}</span>
                        </div>
                        <el-button size="mini" type="success" circle icon="el-icon-check" @click="setScene(scene)" :disabled="form.sceneID == scene.id ? true : false"></el-button>
                      </el-tooltip>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("liveSessions.editLiveStream.scenes.delete") }}</span>
                        </div>
                        <el-popconfirm @confirm="deleteScene(scene.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                          <el-button slot="reference" size="mini" type="danger" circle icon="fas fa-trash" :loading="loading == id + '-deletescene'"></el-button>
                        </el-popconfirm>
                      </el-tooltip>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("liveSessions.editLiveStream.scenes.copy") }}</span>
                        </div>
                        <el-button size="mini" type="warning" circle :icon="loading == 'copyScene-' + scene.id ? 'el-icon-loading' : 'fas fa-clone'" :disabled="loading == 'copyScene-' + scene.id" @click="copyScene(scene)"></el-button>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </VueSlickCarousel>
            </el-row>
          </el-row>

          <el-row v-if="menuType == 4">
            <el-col :span="24">
              <div class="custom-section-container p-0">
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper m-0">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("liveSessions.editLiveStream.settings.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("liveSessions.editLiveStream.settings.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.isLive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isLive ? 'fa-video' : 'fa-video-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("liveSessions.editLiveStream.settings.liveBroadcast") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("liveSessions.editLiveStream.settings.liveBroadcastMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isLive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.showWatcherCount ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i :class="form.showWatcherCount ? 'fas fa-user-friends' : 'fas fa-user-times'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("liveSessions.editLiveStream.settings.showViwer") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("liveSessions.editLiveStream.settings.showViwerMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.showWatcherCount"></el-switch>
                      </div>
                    </div>

                    
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("liveSessions.editLiveStream.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteLiveStream" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("liveSessions.editLiveStream.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{ $t("liveSessions.editLiveStream.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import draggable from "vuedraggable";
import axios from "axios";
export default {
  components: { draggable, VueSlickCarousel },
  props: ["id"],
  data() {
    return {
      swiperKey: +new Date(),
      updateForm: {
        id: null,
        title: null,
        top: null,
        bottom: null,
        background: null
      },
      remoteParticipants: [],
      bulkParticipant: [],
      axios,
      isChanged: false,
      validationErrors: [],
      menuType: 0,
      form: null,
      loading: false,
      timeout: null,
      lastSpeakerId: null,
      listParticipants: [],
      topPercent: 0,
      bottomPercent: 0,
      backgroundPercent: 0,
      swiperOption: {
        slidesPerView: 4
      }
    };
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  methods: {
    permControl(publisher){
      if(this.form.publishers.length > 0){
        console.log(publisher,"publisher");
        var activePublishers = this.form.publishers.filter(x => x.isActive == true).length;
        console.log(activePublishers,"apublisher");
        // if(activePublishers > this.eventPermissions.speakerPerRoom){
        //   publisher.isActive = false;
        //   this.openUpgradeDialog();
        // }

      }
    },
    getParticipantItem(id) {
      return this.bulkParticipant.find(x => x.id == id);
    },
    deleteLiveStream() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    addLiveProvider() {
      var provider = {
        id: null,
        title: null,
        url: null,
        type: 0,
        isActive: true
      };
      this.form.externalLivestreamProviders.push(provider);
    },
    async deleteScene(id) {
      this.loading = id + "-deletescene";
      var res = await this.$store.dispatch("liveStreamDeleteScene", id);
      if (!res.data.alert.hasError) {
        if (this.form.sceneID == id) {
          this.form.backgroundBanner = null;
          this.form.topBanner = null;
          this.form.bottomBanner = null;
          this.form.sceneID = null;

          this.updateForm.title = null;
          this.updateForm.id = null;
          this.updateForm.top = null;
          this.updateForm.bottom = null;
          this.updateForm.background = null;
        }
      }
      this.loading = false;
    },
    copySuccess() {
      this.$message.success(this.$t("liveSessions.rtmpMessage"));
    },
    setScene(scene) {
      this.updateForm.title = scene.title;
      this.updateForm.id = scene.id;
      this.updateForm.top = scene.top;
      this.updateForm.bottom = scene.bottom;
      this.updateForm.background = scene.background;

      this.form.backgroundBanner = scene.background;
      this.form.topBanner = scene.top;
      this.form.bottomBanner = scene.bottom;
      this.form.sceneID = scene.id;

      // var cIndex = this.$store.state.livesessions.listScenes.findIndex((x) => x.id == scene.id);
      // this.$store.state.livesessions.listScenes.splice(cIndex, 1);
      // this.$store.state.livesessions.listScenes.unshift(scene);
    },
    async createScene() {
      this.loading = "createSceneLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("liveStreamAddUpdateScene", { title: "Yeni Template" });
        if (!res.data.alert.hasError) {
          this.$store.state.livesessions.listScenes.push(res.data.data.item);
          this.setScene(res.data.data.item);
          this.swiperKey += 1;
        }
        this.loading = false;
      }, 500);
    },
    async copyScene(scene) {
      this.loading = "copyScene-" + scene.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("liveStreamAddUpdateScene", { ...scene, title: "Copy " + scene.title, id: null });
        if (!res.data.alert.hasError) {
          this.$store.state.livesessions.listScenes.push(res.data.data.item);
          this.setScene(res.data.data.item);
          this.swiperKey += 1;
        }
        this.loading = false;
      }, 500);
    },
    async saveScenes() {
      this.loading = "scenesLoading";
      var res = await this.$store.dispatch("liveStreamAddUpdateScene", this.updateForm);
      if (!res.data.alert.hasError) {
        await this.$store.dispatch("listScenes");
      }
      this.loading = false;
    },

    async remoteSearch(query) {
      var payload = {
        skip: 0,
        take: 1000,
        searchTerm: query
      };
      this.loading = "remoteSearch";
      var res = await axios.post("participant/list", payload);
      this.remoteParticipants = res.data.data.items;
      this.loading = false;
    },
    async getBulkParticipants() {
      var payload = [];
      this.form.publishers.map(x => {
        payload.push(x.participantID);
      });
      if (payload.length > 0) {
        var res = await this.$store.dispatch("getBulkParticipants", payload);
        this.bulkParticipant = res;
      }
    },
    async addSpeaker() {
      if (this.lastSpeakerId != null) {
        var attendee = this.remoteParticipants.find(x => x.id == this.lastSpeakerId);
        var payload = {
          id: null,
          participantID: attendee.id,
          isActive: false,
          type: 1,
          publisherID: 0,
          publisherIDScreencast: 0
        };

        if (this.form.publishers.find(x => x.participantID == attendee.id)) {
          this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.alreadyHas"));
        } else {
          this.form.publishers.push(payload);
          await this.getBulkParticipants();
          this.lastSpeakerId = null;
        }
      } else {
        this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.selectAuth"));
      }
    },
    async refresh() {
      this.loading = "refresh";
      await this.getData();
      this.loading = false;
    },
    async save() {
      this.loading = "save";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var a = new Date(this.form.startDate).setHours(8);
        var b = new Date(this.form.endDate).setHours(8);
        this.form.startDate = new Date(a).toISOString();
        this.form.endDate = new Date(b).toISOString();
        var res = await this.$store.dispatch("updateLiveStream", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;

          console.log(a, "A");
          console.log(b, "B");
          var res2 = await this.$store.dispatch("getLiveSessions");
          this.listParticipants = res2.data.data.participants;
        }
        this.loading = false;
      }, 500);
    },
    async getData() {
      this.loading = "updateScreenLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getLiveStream", this.id);
        if (res.data.alert.hasError) {
          this.$emit("closeDialog");
        } else {
          this.listParticipants = res.data.data.participants;
          this.form = res.data.data.item;
          var a = new Date(res.data.data.item.startDate).toLocaleDateString();
          var b = new Date(res.data.data.item.endDate).toLocaleDateString();
          console.log(a, "A");
          console.log(b, "B");
          await this.getBulkParticipants();

          if (this.form.sceneID != null) {
            var scene = null;
            this.$nextTick(() => {
              scene = this.$store.state.livesessions.listScenes.find(x => x.id == this.form.sceneID);
            });
            this.$nextTick(() => {
              this.setScene(scene);
            });
          }
        }

        this.loading = false;
      }, 500);
    },
    topProgress(event) {
      this.topPercent = event.percent;
    },
    topSuccess(response) {
      this.topPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.updateForm.top = response.data.item.url;
      }
    },
    bottomProgress(event) {
      this.bottomPercent = event.percent;
    },
    bottomSuccess(response) {
      this.bottomPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.updateForm.bottom = response.data.item.url;
      }
    },
    backgroundProgress(event) {
      this.backgroundPercent = event.percent;
    },
    backgroundSuccess(response) {
      this.backgroundPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.updateForm.background = response.data.item.url;
      }
    },
    liveProgress(event) {
      this.livePercent = event.percent;
    },
    liveSuccess(response) {
      this.livePercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },

  async created() {
    await this.$store.dispatch("listScenes");
    await this.$store.dispatch("getTags");
    await this.getData();
  }
};
</script>

<style lang="less" scoped>
#edit-live-stream-dialog {
  .el-carousel__container {
    height: 200px;
  }
}

.ls-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(~"100% - 10px");
  height: auto;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin: 5px;
  margin-top: 0px;
}
.live-session-wrapper {
  padding: 20px 120px 20px 120px;
  width: 100%;
}

.rtmp-user-title {
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 6px;
  display: block;
}
.edit-session {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 1rem;
  padding: 0px 120px;
  margin-bottom: 20px;
}

.live-session-container {
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
  background-position: center;
  background-size: cover;
  position: relative;
  background-color: rgba(3, 101, 140, 0.3);

  &.radius {
    border-radius: 8px;
    overflow: hidden;
    cursor: grab;
  }

  .el-upload {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
    color: white;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
    flex-direction: column;
  }

  .live-session-inner {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;

    .live-session-banner {
      width: 100%;
      aspect-ratio: 10/1;
      background-size: contain;
      border-bottom: 2px solid white;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &:last-child {
        border-top: 2px solid white;
        border-bottom: unset;
      }
    }

    .live-session-background {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .message-text {
      span {
        display: block;
        color: white;
        font-size: 14px;
        font-weight: 400;
        text-shadow: 0 0 4px black;
        b {
          font-size: 18px;
          font-weight: 500;
        }
      }
    }

    .live-session-inner {
      display: flex;
      flex: 1;
      width: 100%;
      height: 100%;
    }
  }
}

.reset-btn {
  border: unset;
  background: transparent;
  width: 100%;
  text-align: left;
  padding: 0px;
  margin: 0px;
  cursor: help;
  &:hover {
    background: transparent;
    border: unset;
  }
  &:focus {
    background: transparent;
    border: unset;
  }
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .add-manager-wrapper {
    padding: 1rem;
    background-color: #f1f1f1;
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 0.5rem;
    border-radius: 8px;
    .add-m-title {
      font-weight: bold;
    }
    .add-m-title,
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}

.menu-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  .menu-item {
    background-color: #f1f1f1;
    border-right: none;
    padding: 10px;
    text-align: center;
    font-weight: bold;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &:first-child {
      border-radius: 8px 0 0 8px;
    }
    &:last-child {
      border-radius: 0 8px 8px 0;
    }
    &.active {
      background-color: #03658c;
      color: white;
    }

    span {
      padding: 6px;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.8);
      font-weight: 600;
      color: #505763;
      padding: 5px 10px;
      margin-left: 6px;
    }
  }
  margin-bottom: 1rem;
}
.switch-area {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  .switch-item {
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    .switch-title {
      font-weight: bold;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.speakers-h-title {
  display: grid;
  grid-template-columns: 30px 1fr 200px 100px 20px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f3f3f3;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.header-item {
  i {
    margin-left: 4px;
  }
}
.speakers-h-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    .speaker-task {
      .el-select {
        max-width: 150px;
      }
    }
    grid-template-columns: 30px 1fr 200px 100px 20px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;
    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}

.scenes-slick-base {
  .item {
    padding: 0.5rem;

    .scene-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      height: auto;
      aspect-ratio: 16/9;
      border: 2px solid rgb(226, 223, 223);
      background-position: center;
      background-size: cover;
      background-color: rgb(177, 176, 176);
      .scene-icon-box {
        color: white !important;
        font-weight: bold !important;
        padding: 10px;
        background-color: black;
        border-radius: 8px;
        min-width: 50px;
        text-align: center;
        width: max-content;
      }
    }
    .scene-box {
      &.active {
        border: 2px solid #03658c;
      }
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      height: auto;
      aspect-ratio: 16/9;
      background-position: center;
      background-size: cover;
      position: relative;
      background-color: grey;
      border: 2px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top-banner {
        width: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        aspect-ratio: 10/1;
        height: auto;
        border-bottom: 2px solid #ccc;
      }
      .bottom-banner {
        width: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        height: auto;
        aspect-ratio: 10/1;

        position: absolute;
        bottom: 0;
        border-top: 2px solid #ccc;
      }
    }
    .info-box {
      .info-box-title {
        font-weight: bold;
        text-align: center;
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
      }
      .info-btns {
        display: flex;
        justify-content: center;
        gap: 0.2rem;
      }
    }
  }
}
.rtmp-preview {
  .preview-container {
    padding: 3rem;
    video {
      height: 300px;
      border: 2px solid #03568c;
      border-radius: 8px;
    }
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    .preview-title {
      font-weight: bold;
      color: black;
    }
  }
}
.rtmp-container {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 1rem;

  .info-icon {
    background-color: rgba(6, 101, 140, 0.22);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    color: black;
    font-size: 15px;
    border-radius: 8px;
  }
  .info-box {
    background-color: #f3f3f3;
    border-radius: 8px;
    padding: 1rem;
    font-display: 15px;
    color: black;
    .info-title {
      font-weight: bold;
    }
    .info-detail {
      font-weight: 400;
    }
    .rtmp-url {
      background-color: white;
      padding: 10px 12px;
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      i {
        color: #03658c;
        margin-right: 8px;
      }
      span {
        line-height: 16px;
        color: #606266;
        font-weight: 500;
      }
    }
  }
}
.external-link-title {
  display: grid;
  grid-template-columns: 36px 180px 180px 1fr 90px 20px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f1f1f1;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}
.switch-title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.external-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  max-width: 250px;
}

.empty-box {
  justify-content: center;
  padding: 1rem;
  border: 4px solid #f1f1f1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  cursor: pointer;
  gap: 1rem;
  position: relative;
  background-color: #f1f1f1;
  .logo-side {
    text-align: center;
    img {
      width: 60%;
      height: auto;
      margin-bottom: 9px;
    }
  }
  .text-side {
    text-align: center;
    color: black;
    font-weight: 500;
  }
}
.external-link-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        .networking-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
        }
        span {
          font-size: 13px;
          display: block;
          font-weight: 500;
          color: #505763;
          line-height: normal;
        }
      }
      & > img {
        border-radius: 8px;
        width: 50px;
        height: 50px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 36px 180px 180px 1fr 90px 20px;
    gap: 0.5rem;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
</style>
<style>
#edit-live-stream .el-carousel__container {
  height: 200px !important;
}
.slick-prev:before,
.slick-next:before {
  color: #03658c;
}
</style>



// WEBPACK FOOTER //
// src/components/live-stream/editLiveStream.vue